import type { RouterConfig } from '@nuxt/schema';

export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    const nuxtApp = useNuxtApp();

    return new Promise((resolve) => {
      nuxtApp.hooks.hookOnce('page:finish', async () => {
        await nextTick();

        if (savedPosition) {
          resolve(savedPosition);
        }

        resolve({
          top: 0,
          behavior: 'instant'
        });
      });
    });
  }
};
